module.exports = __webpack_public_path__ + "img/baixuanz.59c328f6.svg";